var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invalid-elements-wrapper"},_vm._l((_vm.error_list),function(err,key){return _c('div',{key:key,staticClass:"invalid-element"},[_vm._v(" "+_vm._s(err)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }